import React from 'react';
import { Header } from '../components/Header';
import { EvaSchiffererFooter } from '../components/EvaSchiffererFooter';
export function EvaSchiffererPage() {
  return <div className="min-h-screen bg-white" data-id="element-1738">
      <Header data-id="element-1739" />
      <main className="w-full pt-[152px]" data-id="element-1740">
        {/* Hero Section mit Bild und Zitat */}
        <div className="w-full flex justify-center" data-id="element-1741">
          <div className="relative w-full max-w-[1600px] h-[500px]" data-id="element-1742">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/scdqsQeX2PuCAeDjgM3ENR/Header-Startseite-Eva_Schifferer.jpg" alt="Eva Sophie Schifferer" className="w-full h-full object-cover object-[70%_center]" data-id="element-1743" />
            <div className="absolute inset-0 bg-black bg-opacity-30" data-id="element-1744"></div>
            <div className="absolute inset-0 flex items-end pb-16 md:pb-40" data-id="element-1745">
              <div className="max-w-5xl w-full mx-auto px-6 md:px-12" data-id="element-1746">
                <div className="max-w-lg text-left" data-id="element-1747">
                  <blockquote className="text-white text-2xl md:text-3xl font-light italic mb-4" data-id="element-1748">
                    „Wege entstehen dadurch, dass man sie geht"
                  </blockquote>
                  <p className="text-white text-xl" data-id="element-1749">– Franz Kafka</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Willkommenstext */}
        <div className="max-w-5xl mx-auto py-16 px-6 md:px-12" data-id="element-1750">
          <h1 className="text-3xl md:text-4xl font-light text-gray-700 mb-8" data-id="element-1751">
            Herzlich willkommen
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-1752">
            auf der Website meiner Privatpraxis für Coaching, Paarberatung und
            Einzeltherapie in Frankfurt am Main.
          </p>
          <div className="grid md:grid-cols-2 gap-12 items-stretch mb-12" data-id="element-1753">
            <div className="text-lg text-gray-600 leading-relaxed space-y-6" data-id="element-1754">
              <p data-id="element-1755">
                In meiner Praxis begleite ich Einzelpersonen und Paare in
                Veränderungs-, Belastungs- und Entwicklungsphasen – mit Respekt,
                Klarheit und Wertschätzung. Ob in akuten Krisen, bei anhaltenden
                Konflikten oder mit dem Wunsch nach persönlicher
                Weiterentwicklung: Gemeinsam schaffen wir Raum für Reflexion,
                Orientierung und neue Perspektiven.
              </p>
              <p data-id="element-1756">
                Manchmal wird das Leben komplizierter, als wir es geplant
                hatten. Genau dann kann es hilfreich sein, innezuhalten – und
                sich professionell unterstützen zu lassen.
              </p>
            </div>
            <div className="h-full" data-id="element-1757">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/i74dsMhga2BTGpt94tQ51L/Eva_Schifferer-Motivation.jpg" alt="Notizzettel mit Werten: Verständnis, Vertrauen, Toleranz und Ergebnisoffen" className="w-full h-full rounded-lg shadow-md object-cover" data-id="element-1758" />
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-stretch" data-id="element-1759">
            <div className="bg-[#c2cde0] p-6 rounded-lg border-l-4 border-white flex flex-col justify-center" data-id="element-1760">
              <blockquote className="text-xl font-light text-white mb-3 italic" data-id="element-1761">
                „Leben ist das, was dir passiert, während du dabei bist, andere
                Pläne zu schmieden."
              </blockquote>
              <p className="text-right text-gray-600" data-id="element-1762">– John Lennon</p>
            </div>
            <div className="text-lg text-gray-600 leading-relaxed flex items-center" data-id="element-1763">
              <p data-id="element-1764">
                Mit einem breit gefächerten methodischen Fundament aus
                systemischer Beratung und Therapie, Coaching sowie kognitiver
                Verhaltenstherapie unterstütze ich Sie darin, Herausforderungen
                zu meistern – mit einem Ansatz aus Pragmatismus sowie
                Wertschätzung für Ihre Person und Ihr Anliegen.
              </p>
            </div>
          </div>
          <div className="mt-12 text-center space-y-4" data-id="element-1765">
            <p className="text-gray-600" data-id="element-1766">
              Die Rahmenbedingungen wie Terminvereinbarung, Ablauf und Kosten
              finden Sie unter{' '}
              <a href="/eva_schifferer/info" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1767">
                Info
              </a>
              .
            </p>
            <p className="text-gray-600" data-id="element-1768">
              Appointments are also possible in English. Please contact me via{' '}
              <a href="mailto:praxis@evaschifferer.com" className="text-[#c2cde0] hover:text-[#a3b3d4] hover:font-semibold transition-colors" data-id="element-1769">
                email
              </a>{' '}
              for sessions in English!
            </p>
          </div>
        </div>
      </main>
      <EvaSchiffererFooter data-id="element-1770" />
    </div>;
}